import { render, staticRenderFns } from "./authRole.vue?vue&type=template&id=40135cd7&scoped=true"
import script from "./authRole.vue?vue&type=script&lang=js"
export * from "./authRole.vue?vue&type=script&lang=js"
import style0 from "./authRole.vue?vue&type=style&index=0&id=40135cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40135cd7",
  null
  
)

export default component.exports